import React, { forwardRef } from 'react';

/**
 * Universal Card Component with Premium Hairline Gradient Border System
 * 
 * Supports variants:
 * - 'default': Standard card with dual-clip hairline gradient border & glass edge highlight
 * - 'interactive': Adds subtle translateY and soft gold glow on hover
 * - 'kpi': Adds the signature gold top-right corner hairline accent
 * - 'subtle': Subtle 1px border for secondary panels/nested frames
 * - 'active': Full accent gold border with accent-soft glow
 */
export const Card = forwardRef(function Card(
  {
    as: Component = 'div',
    variant = 'default',
    className = '',
    children,
    ...props
  },
  ref
) {
  const variantClasses = {
    default: 'card-border',
    interactive: 'card-border card-border-interactive',
    kpi: 'card-border card-border-interactive kpi-corner-accent',
    subtle: 'card-border-subtle',
    active: 'card-border card-border-active',
  };

  const selectedClass = variantClasses[variant] || variantClasses.default;

  return (
    <Component
      ref={ref}
      className={`${selectedClass} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
});

Card.displayName = 'Card';

export default Card;
